import { render, staticRenderFns } from "./ManageReasons.vue?vue&type=template&id=6f846342&scoped=true"
import script from "./ManageReasons.vue?vue&type=script&lang=js"
export * from "./ManageReasons.vue?vue&type=script&lang=js"
import style0 from "./ManageReasons.vue?vue&type=style&index=0&id=6f846342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f846342",
  null
  
)

export default component.exports